module.exports = __webpack_public_path__ + "static/img/Rectangle 13.96fbe51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Rectangle 13.png
// module id = /MTr
// module chunks = 1